<div class="fulfill-top-sec">
  <div class="row listing-action-items">
    <div class="flex-one text-right">
      <div class="display-ib wAuto quote-pagination">
        <mat-paginator #blanketCPPOrdersPaginator [pageSize]="masterConstants.PAGE_SIZE" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
      </div>
    </div>
  </div>
</div>

<div class="tableContainer dealertableContainer table-mobile quoteTableContainer blanketOrderTable">
  <table mat-table #blanketOrderCPPOrdersTable [dataSource]="blanketCPPOrdersDataSource" matSort #blanketCPPOrdersSort
         matSortDirection="desc" multiTemplateDataRows class="matTables">

    <ng-container matColumnDef="{{column}}" *ngFor="let column of blanketOrderCPPOrdersColumns">
      <div *ngIf="column == 'blanketOrderNumber'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="blanketOrderNumber">Order Number</th>
</div>
<div *ngIf="column == 'accountName'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="accountName pl-4">Account Name</th></div>
<div *ngIf="column == 'accountNumber'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="accountNumber justify-content-center-child pl-3">Account #</th></div>
<div *ngIf="column == 'blanketOrderDate'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="status justify-content-center-child">Order Date</th></div>
<div *ngIf="column == 'blanketOrderCloseDate'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="quoteDate justify-content-center-child">Order Close Date</th></div>
<div *ngIf="column == 'blanketOrderStatus'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="closeDat justify-content-center-child pl-2">Order Status</th></div>
<div *ngIf="column == 'customerPONumber'"><th mat-header-cell *matHeaderCellDef mat-sort-header class="preparedBy justify-content-center-child">Customer PO #</th></div>
<div *ngIf="column == 'openLines'" class="d-none d-sm-none d-md-block"><th mat-header-cell *matHeaderCellDef mat-sort-header class="openLines justify-content-center-child">Open Lines</th></div>
<div *ngIf="column == 'Lines'" class="d-none d-sm-none d-md-block"><th mat-header-cell *matHeaderCellDef mat-sort-header class="openLines justify-content-center-child">Lines</th></div>
<div *ngIf="column == 'contextMenu'"><th mat-header-cell *matHeaderCellDef class="contextMenu">&nbsp;</th></div>
<div *ngIf="column == 'contextMenuDraft'"><th mat-header-cell *matHeaderCellDef class="contextMenu">&nbsp;</th></div>

<td mat-cell *matCellDef="let elementOuter">
  <div *ngIf="column=='blanketOrderNumber'">
    <div class="d-block d-sm-block d-md-none sm-block">Early Advantage Order Number</div>
    <div (click)="viewBlanketOrder(elementOuter)" class="pl-2">
      <a>{{elementOuter.blanketOrderNumber}}</a>
    </div>
  </div>

  <div *ngIf="column=='accountName'" class="order-info defaultCursor">
    <div class="d-block d-sm-block d-md-none sm-block">Account Name</div>
    <p class="grower-name">
      {{elementOuter.accountName}}
    </p>
    <p>{{elementOuter.accountAddress1 || elementOuter.accountAddress2}}, {{elementOuter.accountCity}}, {{elementOuter.accountState}} {{elementOuter.accountZipCode}}</p>
  </div>

  <div *ngIf="column=='accountNumber'" class="defaultCursor text-center">
    <div class="d-block d-sm-block d-md-none sm-block">Account #</div>
    {{elementOuter.accountNumber}}
  </div>

  <div *ngIf="column=='blanketOrderDate'" class="defaultCursor text-center">
    <div class="d-block d-sm-block d-md-none sm-block">Early Advantage Order Date</div>
    {{elementOuter.blanketOrderDate | date:'MM/dd/yyyy'}}
    <!--{{elementOuter.blanketOrderDate}}-->
  </div>

  <div *ngIf="column=='blanketOrderCloseDate'" class="defaultCursor text-center">
    <div class="d-block d-sm-block d-md-none sm-block">Early Advantage Close Date</div>
    {{elementOuter.blanketOrderCloseDate | date:'MM/dd/yyyy'}}
    <!--{{elementOuter.blanketCloseDate}}-->
  </div>

  <div *ngIf="column=='blanketOrderStatus' && elementOuter.blanketOrderStatus=='CLOSED'" class="defaultcursor text-center">
    <div class="d-block d-sm-block d-md-none sm-block">Early Advantage Order Status</div>
    <button class="roundedBtn">{{elementOuter.blanketOrderStatus}}</button>
  </div>
  <div *ngIf="column=='blanketOrderStatus' && elementOuter.blanketOrderStatus!='CLOSED'" class="defaultcursor text-center">
    <div class="d-block d-sm-block d-md-none sm-block">Early Advantage Order Status</div>
    {{elementOuter.blanketOrderStatus}}
  </div>

  <div *ngIf="column=='customerPONumber'" class="defaultCursor text-center">
    <div class="d-block d-sm-block d-md-none sm-block">customer PO#</div>
    {{elementOuter.customerPONumber}}
  </div>

  <div *ngIf="column=='openLines'" class="text-center d-none d-sm-none d-md-block">
    <div class="d-block d-sm-block d-md-none sm-block">Open Lines</div>
    {{elementOuter.blanketOrderStatus !='OPEN'? '': elementOuter.openLines }}
  </div>

  <div *ngIf="column=='Lines'" class="text-center d-none d-sm-none d-md-block">
    <div class="d-block d-sm-block d-md-none sm-block">Lines</div>
    {{elementOuter.blanketOrderStatus !='DRAFT'? '': elementOuter.openLines }}
  </div>

  <div *ngIf="column=='contextMenu'" class="text-center d-flex align-items-center">
    <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
      <i class="fas fa-ellipsis-v"></i>
    </button>
    <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
      <button mat-menu-item (click)="viewBlanketOrder(elementOuter)">View Early Advantage Order</button>
      <button mat-menu-item (click)="generateBlanketPdf(elementOuter)">Download PDF</button>
      <button mat-menu-item (click)="emailBlanketOrder(elementOuter)">Email Early Advantage Orders</button>
    </mat-menu>
  </div>
  <div *ngIf="column=='contextMenuDraft'" class="text-center d-flex align-items-center">
    <button mat-button [matMenuTriggerFor]="beforeMenu1" class="context-menu">
      <i class="fas fa-ellipsis-v"></i>
    </button>
    <mat-menu #beforeMenu1="matMenu" xPosition="before" class="context-meun-dropdown">
      <button mat-menu-item (click)="viewBlanketOrder(elementOuter)">Edit Order</button>
      <button mat-menu-item (click)="deleteOrder(elementOuter)">Delete Order</button>
    </mat-menu>
  </div>
</td>
    </ng-container>
<tr mat-header-row *matHeaderRowDef="blanketOrderCPPOrdersColumns;sticky:true;"></tr>
<tr mat-row *matRowDef="let element; columns: blanketOrderCPPOrdersColumns;" [class.example-element-row]="element.blanketOrderCPPOrdersList?.data.length"
    [class.example-expanded-row]="element.isExpanded"></tr>
  </table>
<div *ngIf="blanketOrderCPPOrdersList == undefined || blanketOrderCPPOrdersList.length == 0" class="noDataMsg">
  <p class="padding-b47">No Record Found.</p>
</div>
